import { Link } from 'react-router-dom';
import { courseBenefits } from '@/mocks/advancedCourseData';
import { useTranslation } from 'react-i18next';

const BENEFIT_COUNT = 5;
const benefitIndices = Array.from({ length: BENEFIT_COUNT }, (_, i) => i);

export default function CourseBenefits() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('coursesAdvanced.benefits.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesAdvanced.benefits.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('coursesAdvanced.benefits.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto mb-8">
          {benefitIndices.map((index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-5 border border-background-200/60 bg-background-50 group hover:border-accent-500/20 transition-colors duration-300"
            >
              <span className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={`${courseBenefits[index]?.icon} text-accent-600 text-lg group-hover:text-accent-500 transition-colors duration-300`}></i>
              </span>
              <div>
                <h4 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-1.5">
                  {t(`coursesAdvanced.benefits.${index}.title`)}
                </h4>
                <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]">
                  {t(`coursesAdvanced.benefits.${index}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/benefits"
            className="inline-flex items-center gap-2 text-[14px] text-accent-600 hover:text-accent-500 tracking-[0.08em] transition-colors duration-300"
          >
            <span>{t('coursesAdvanced.benefits.detailLink')}</span>
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
